import React from 'react'
import { Select, MenuItem, InputLabel } from '@mui/material'
import { useUsStateLuts } from 'components'

export interface StateRef {
  id: number
}
export interface State extends StateRef {
  desc?: string
  abbrev?: string
  code?: string | null
}

const NON_US_STATE_IDS = new Set([0, 57, 58, 59])

export const UsStateSelect: React.FC<{
  value: State | null
  updateState: (state: State | null) => void
  disabled: boolean
  onlyUSStates?: boolean
}> = ({ value, updateState, disabled, onlyUSStates = false }) => {
  const { lutValues, loading } = useUsStateLuts()

  const handleChange = (value: string | number): void => {
    const selectedOption = lutValues.states.get(value as number)
    updateState(selectedOption ?? null)
  }

  const filteredOptions = Array.from(lutValues.states.values()).filter(option =>
    !onlyUSStates || !NON_US_STATE_IDS.has(option.id) || option.id === value?.id
  )

  const displayOptions = value != null && !filteredOptions.some(option => option.id === value.id)
    ? [...filteredOptions, value]
    : filteredOptions

  return (
    <React.Fragment>
      <InputLabel>State</InputLabel>
      <Select
        label="State"
        value={value?.id ?? ''}
        onChange={(event) => { handleChange(event.target.value) }}
        disabled={disabled || loading}
        fullWidth
      >
        <MenuItem value="">
          None
        </MenuItem>
        {displayOptions.map(option => (
          <MenuItem key={option.id} value={option.id}>
            {option.desc}
          </MenuItem>
        ))}
      </Select>
    </React.Fragment>
  )
}
